<template>
  <div>
    <b-form v-if="currentRow">
      <b-card style="margin: 1%">
        <b-row>
          <b-col md="1" cols="0" xl="1"/>
          <b-col md="10" cols="12" xl="10" >
            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" label="ID" disabled>
              <b-form-input id="input-number" type="number" v-model="currentRow.user_id"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Basic account')"  disabled>
              <b-form-input type="number" v-model="currentRow.basic_account"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Login')" @validation="validation">
              <b-form-input type="text" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim v-model="currentRow.login"/>
              <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('Enter only english letters, numbers, at least 1 letter') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Name')" >
              <b-form-input type="text" v-model="currentRow.full_name"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Password')" >
              <b-form-input type="password" v-model="currentRow.password"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Confirm password')" >
              <b-form-input type="password" v-model="currentRow.confirmPassword"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="$t('Payment in advance')" >
              <b-form-checkbox v-model="currentRow.advance_payment"/>
            </b-form-group>

          </b-col>
        </b-row>
      </b-card>
    </b-form>
  </div>
</template>

<script>

export default {
  props: {
    currentRow: null
  },
  methods: {
    validation () {
      if (this.currentRow.login.length === 0) {
        return false
      }
      let strArray = this.currentRow.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.currentRow.login.length
    }
  },
  computed: {
    inputLoginState () {
      return this.validation()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/main/main.vue